import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const Page404 = modules[vendor] ? modules[vendor] : modules["default"];

export default Page404;
